import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ManageConfigureCostObject from './ManageConfigureCostObject';
import { fetchCostObjsByAllocationUnitId, fetchAllCostObjs, selectedCostObject, clearCostObjects } from 'redux/costObjs/CostObjsActions';


const mapStateToProps = ({ costObjs }) => ({
  fetchingCostObjs: costObjs.fetchingCostObjs,
  costObjs: costObjs.costObjs,
  allCostObjs: costObjs.allCostObjs
});

const mapDispatchToProps = dispatch => ({
  costObjsActions: bindActionCreators({ fetchCostObjsByAllocationUnitId, fetchAllCostObjs, selectedCostObject, clearCostObjects }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageConfigureCostObject);



// WEBPACK FOOTER //
// ./src/components/manageRules/comp/ruleEditor/comp/ruleBuilder/allocationContainer/ManageConfigureCostObjectConnector.js